import {Injectable} from "@angular/core";
import {ReportTypesService} from "../../../../../common/api";
import {HttpClient} from "@angular/common/http";


@Injectable()
export class BackofficeReportTypesService extends ReportTypesService {
    static readonly context = 'backoffice'

    constructor(http: HttpClient) {
        super(http, BackofficeReportTypesService.context);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/backoffice-report-types.service.ts